import { z } from "zod";

export const addProductSchema = z.object({
  brand: z.string().min(1, "Brand is required"),
  categories: z.array(z.string()).min(1, "At least one category must be selected"),
  name: z.string().min(1, "Name is required"),
  variants: z
    .array(
      z.object({
        description: z.string().min(1, "Description is required"),
        price: z
          .number()
          .nonnegative("Price must be a non-negative number")
          .min(0.01, "Price must be greater than 0"),
        images: z.any(),
        sku: z.string().min(2, "SKU is required"),
        on_hand: z
          .number()
          .int()
          .nonnegative("On hand must be a non-negative integer")
          .min(0, "On hand must be greater than or equal to 0"),
        show_by_default: z.boolean(),
        attributes: z.record(z.string(), z.string()).optional(),
      })
    )
    .min(1, "At least one variant is required"),
});
